'use client';

export { default } from './Collapse';
export { default as collapseClasses } from './collapseClasses';
export * from './collapseClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Collapse/index.js
// module id = 315
// module chunks = 25